import { DateTime } from 'luxon';

import { BOOLEAN_VALUE } from '../constants/import-export.constants';

export class DataTableConverter {

  public static toString(value: any): string {
    return String(value);
  }

  public static toBoolean(value: string): boolean {
    if (value === BOOLEAN_VALUE.False) {
      return false;
    }
    if (value === BOOLEAN_VALUE.True) {
      return true;
    }
    this.throwParseException(value, 'boolean');
  }

  public static toNumber(value: string): number {
    const parsedValue = Number(value);
    if (!isNaN(parsedValue)) {
      return parsedValue;
    }
    this.throwParseException(value, 'number');
  }

  public static toDate(value: string, format: string): Date {
    const parsedValue = DateTime.fromFormat(value, format);
    if (parsedValue.isValid) {
      return parsedValue.toJSDate();
    }
    this.throwParseException(value, 'Date', `expected format: '${format}'`);
  }

  private static throwParseException(value: string, typeDescription: string, additionalInformation?: string): never {
    const errorData = { value, typeDescription, additionalInformation };
    throw new Error(`DataTableConverter: failed to parse value (${JSON.stringify(errorData)})`);
  }
}
